'use client';

import { useRef, type ReactNode } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import '@/lib/i18n';

import { makeStore } from '@/app/store/store';

import AppShell from '../AppShell';
import LoaderOverlayTransition from '../shared/loaders/LoaderOverlayTransition';

type Props = {
  children: ReactNode;
  variantApp: 'root' | 'app' | 'dashboard' | 'onboarding';
};

export default function AppProviders({ children, variantApp }: Props) {
  const storeRef = useRef<ReturnType<typeof makeStore> | null>(null);

  if (!storeRef.current) {
    storeRef.current = makeStore();
  }

  const storeBag = storeRef.current;
  if (!storeBag) {
    throw new Error('Store was not initialised');
  }

  const { store, persistor } = storeBag;

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <AppShell variant={variantApp === 'onboarding' ? 'dashboard' : variantApp}>
          {children}
          <LoaderOverlayTransition />
        </AppShell>
      </PersistGate>
    </Provider>
  );
}
